module.exports = __webpack_public_path__ + "static/img/aboutus_logo.81a0c39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/aboutus_logo.png
// module id = 3y4V
// module chunks = 6